var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0E2240",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.014 16.255H2.6V8.497a1.55 1.55 0 0 1 1.552-1.552h14.9A1.55 1.55 0 0 1 20.6 8.497v7.758h-3.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E2240",
    d: "M17.042 10.071a.787.787 0 1 0 0-1.574.787.787 0 0 0 0 1.574"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E2240",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.014 5.083V2.6h11.172v2.483M6.014 12.29h11.172v8.31H6.014z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h19.2v19.2H2z"
  })))));
};
export { SvgPrint as ReactComponent };
export default "/_next/static/images/Print.svg";